<template>
  <!-- <ScaleBox
    :width="1920"
    :height="1080"
    bgc="transparent"
    :delay="10"
    :isFlat="true"
  > -->
  <!-- <template>
        <h1>大屏内容</h1>
      </template> -->

  <el-container class="layout">
    <!-- 头部 -->

    <el-header class="header">
      <div class="headermar">
        <div class="heaLeft">
          <img class="heaImg" src="@/assets/logo.png" alt="" />
          <!-- <div class="hlTop">VOYSTAR</div>
        <div class="hlbtm">VENTURES</div> -->
        </div>
        <div class="heaRight">
          <!-- home -->
          <div class="rightBox" @click="toHome">Home</div>
          <!-- Solutions -->
          <!-- <div class="rightBox">
          <div class="dropdown">
            <div class="dropbtn" @click="toSolutions(1)">
              Solutions<i class="el-icon-arrow-down"></i>
            </div>
            <div class="dropdown-content">
              <p @click="toSolutions(1)">Solutions one</p>
              <p @click="toSolutions(2)">Solutions two</p>
              <p @click="toSolutions(3)">Solutions three</p>
              <p @click="toSolutions(4)">Solutions four</p>
            </div>
          </div>
        </div> -->
          <!-- Products -->
          <div class="rightBox">
            <div class="dropdown">
              <div class="dropbtn" @click="toProducts(1)">
                Products<i class="el-icon-arrow-down"></i>
              </div>
              <div class="dropdown-content">
                <p @click="toProducts(1)">Antenna</p>
                <p @click="toProducts(2)">2G/3G/4G Radio</p>
                <p @click="toProducts(3)">4G/5G CPE</p>
                <p @click="toProducts(4)">GPON OLT/ONT</p>
                <p @click="toProducts(5)">Optical Fiber Accessories</p>
                <p @click="toProducts(6)">Optical Transmission</p>
                <p @click="toProducts(7)">Server</p>
                <p @click="toProducts(8)">Storage</p>
                <p @click="toProducts(9)">Telecom Power</p>
              </div>
            </div>
          </div>
          <!-- 机器 -->
          <div class="rightBox">
            <div class="dropdown">
              <div class="dropbtn" @click="toProducts(1)">
                Robotic<i class="el-icon-arrow-down"></i>
              </div>
              <div class="dropdown-content">
                <p @click="toRobotic(1)">Robotic Dog</p>
                <p @click="toRobotic(2)">Unmanned Aerial Vehicle</p>
              </div>
            </div>
          </div>
          <!--  About Us -->
          <div class="rightBox">
            <div class="dropdown">
              <div class="dropbtn" @click="toOverview">
                About Us<i class="el-icon-arrow-down"></i>
              </div>
              <div class="dropdown-content">
                <p @click="toOverview">Company Overview</p>
                <p @click="toCompanyNews">Company News</p>
                <p @click="toAbout">Contact us</p>
              </div>
            </div>
          </div>
        </div>
        <div class="voyage">Voyage</div>
        <div class="moreBox" @click="drawer = true">
          <img class="moreImg" src="@/assets/more.png" alt="" />
        </div>
      </div>
    </el-header>
    <!-- 中部-->
    <el-main class="main">
      <!-- 首页的内容 -->
      <div class="mainInsid">
        <div class="mainBox" v-if="$route.fullPath == '/'">
          <!-- <div class="mainTop">
          <div class="mainItemTop">
            <h2 class="mainTitle">INDUSTRY SOLUTIONS</h2>
            <p class="more" @click="toSolutions(1)">
              Learn More Solutions <i class="el-icon-arrow-right"></i>
            </p>
          </div>
          <div class="mainItemBtm">
            <div
              class="mainItemCon"
              v-for="(item, index) in solutionList"
              :key="index"
              @click="toSolutions(item.value)"
            >
              <img class="mainImg" :src="item.img" alt="" />
              <p class="mainText">{{ item.name }}</p>
            </div>
          </div>
        </div> -->
          <div class="mainCenter">
            <div class="mainItemTop">
              <h2 class="mainTitle">PRODUCTS CENTER</h2>
              <p class="more" @click="toProducts(1)">
                Learn More Products<i class="el-icon-arrow-right"></i>
              </p>
            </div>
            <h2 class="mainTitleSmall">PRODUCTS CENTER</h2>
            <div class="mainCentItemBox">
              <div
                class="mainItemBtm"
                v-for="(item, index) in productsList"
                :key="index"
                @click="toProducts(item.value)"
              >
                <div class="mainItemCon">
                  <h2>{{ item.title }}</h2>
                  <div class="mainItemBox">
                    <div class="mainItemImg">
                      <img class="mainImg" :src="item.img" alt="" />
                    </div>
                    <p class="mainText">
                      {{ item.text }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <p class="more" @click="toProducts(1)">
              Learn More Products<i class="el-icon-arrow-right"></i>
            </p>
          </div>
        </div>
        <div class="mainBoxTwo" v-if="$route.fullPath == '/'">
          <div class="mainBtm">
            <div class="mainItemTop">
              <h2 class="mainTitle">Four Reasons To Choose Us</h2>
            </div>
            <div class="mainBtmBox">
              <div class="mainBtmBoxLeft">
                <div class="itemLeftBox">
                  <div class="itemLeft">1</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Best Price & Quality</h2>
                    <p>> 80%~98% Off Global List Price</p>
                    <p>> Best price Guarantee</p>
                    <p>> Original brand new sealed</p>
                    <p>> Test report for used equipment</p>
                  </div>
                </div>
                <div class="itemLeftBox">
                  <div class="itemLeft">3</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Guarantee & Warranty</h2>
                    <p>> Safe payment and Money-back guarantee</p>
                    <p>> Reputation with 900+ buyers over 80 countries</p>
                    <p>> 1~5 years warranty</p>
                    <!-- <p>> 4 years Golden Supplier in Alibaba</p> -->
                  </div>
                </div>
              </div>
              <div class="mainBtmBoxCen">
                <img class="mainImg" src="@/assets/logo.png" alt="" />
                <div class="mainbbcTop">Voyage</div>
                <!-- <div class="mainbbcBtm">VENTURES</div> -->
              </div>
              <div class="mainBtmBoxRight">
                <div class="itemLeftBox">
                  <div class="itemLeft">2</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Fast Delivery</h2>
                    <p>> 10 million stock ready to ship</p>
                    <p>> Ship within 24 hours</p>
                    <p>> DHL/Fedex/TNT/UPS</p>
                    <p>> Worldwide arrive within 2~3 days</p>
                  </div>
                </div>
                <div class="itemLeftBox">
                  <div class="itemLeft">4</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Professional Support</h2>
                    <p>> Huawei HCIE & CISCO CCIE Support</p>
                    <p>> 10 years experienced expert 7*24 Hours service</p>
                    <p>> Network designs and solutions</p>
                    <p>
                      > Consultancy, configuration, troubleshooting, training
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mainBtmBoxSmall">
              <div class="mainBtmBoxLeft">
                <div class="itemLeftBox">
                  <div class="itemLeft">1</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Best Price & Quality</h2>
                    <p>> 80%~98% Off Global List Price</p>
                    <p>> Best price Guarantee</p>
                    <p>> Original brand new sealed</p>
                    <p>> Test report for used equipment</p>
                  </div>
                </div>
                <div class="itemLeftBox">
                  <div class="itemLeft">2</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Fast Delivery</h2>
                    <p>> 10 million stock ready to ship</p>
                    <p>> Ship within 24 hours</p>
                    <p>> DHL/Fedex/TNT/UPS</p>
                    <p>> Worldwide arrive within 2~3 days</p>
                  </div>
                </div>
                <div class="itemLeftBox">
                  <div class="itemLeft">3</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Guarantee & Warranty</h2>
                    <p>> Safe payment and Money-back guarantee</p>
                    <p>> Reputation with 900+ buyers over 80 countries</p>
                    <p>> 1~5 years warranty</p>
                    <!-- <p>> 4 years Golden Supplier in Alibaba</p> -->
                  </div>
                </div>
                <div class="itemLeftBox">
                  <div class="itemLeft">4</div>
                  <div class="itemRight">
                    <h2 class="itemRightTitle">Professional Support</h2>
                    <p>> Huawei HCIE & CISCO CCIE Support</p>
                    <p>> 10 years experienced expert 7*24 Hours service</p>
                    <p>> Network designs and solutions</p>
                    <p>
                      > Consultancy, configuration, troubleshooting, training
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-for="(item, index) in newList" :key="index">
        {{ item.time }}
        <img :src="item.img" alt="">
      </div>
      <img src="../../public/imgs/email.png" alt=""> -->

      <!-- <el-button @click="btn">按钮</el-button> -->
      <!-- 跳转其他页面的内容 -->
      <!-- <keep-alive include="products"> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </el-main>
    <!-- 底部 -->
    <el-footer class="footer">
      Copyright © 2023 Voyage - All Rights Reserved</el-footer
    >
    <!-- 关于我们 -->
     <!-- 微信 -->
    <el-popover placement="left" width="100" trigger="hover">
      <img style="width: 120px;height: 120px;" src="@/assets/wechatCode1.png" alt="" />
      <div slot="reference" class="aboutWechat">
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/wechat1.png" alt="" />
        </div>
        <p class="aboutTxt">WeChat</p>
      </div>
    </el-popover>
    <!-- WhatsApp -->
    <el-popover placement="left" width="100" trigger="hover">
      <img style="width: 120px;height: 120px;" src="@/assets/wechatCode.png" alt="" />
      <div slot="reference" class="aboutWhatsApp">
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/wechat.png" alt="" />
        </div>
        <p class="aboutTxt">WhatsApp</p>
      </div>
    </el-popover>
    <div class="aboutPhone" @click="toAbout">
      <div class="aboutItem">
        <img class="aboutImg" src="@/assets/phone.png" alt="" />
      </div>
      <p class="aboutTxt">Telephone</p>
    </div>
    <!-- <div class="aboutBox">
      <div
        class="aboutCon"
        @mouseenter="wechatEnterCode"
        @mouseleave="wechatLeaveCode"
      >
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/wechat1.png" alt="" />
        </div>
        <p class="aboutTxt">WeChat</p>
      </div>
      <div class="aboutCon" @mouseenter="wechatEnter" @mouseleave="wechatLeave">
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/wechat.png" alt="" />
        </div>
        <p class="aboutTxt">WhatsApp</p>
      </div>
      <div class="aboutCon" @click="toAbout">
        <div class="aboutItem">
          <img class="aboutImg" src="@/assets/phone.png" alt="" />
        </div>
        <p class="aboutTxt">Telephone</p>
      </div>
    </div> -->
    <!-- Wechat二维码 -->
    <div ref="wechat" class="wechatBox">
      <img class="wechatImg" src="@/assets/wechatCode.png" alt="" />
    </div>
    <div ref="wechatCode" class="wechatBoxCode">
      <img class="wechatImg" src="@/assets/wechatCode1.png" alt="" />
    </div>
    <!-- 抽屉 -->
    <el-drawer title="" :size="250" :visible.sync="drawer" direction="rtl">
      <el-collapse v-model="activeNames">
        <div class="collapseHome" @click="toHome">Home</div>
        <el-collapse-item title="Products" name="1">
          <div @click="toProducts(1)" class="cllapseItem">Antenna</div>
          <div @click="toProducts(2)" class="cllapseItem">2G/3G/4G Radio</div>
          <div @click="toProducts(3)" class="cllapseItem">4G/5G CPE</div>
          <div @click="toProducts(4)" class="cllapseItem">GPON OLT/ONT</div>
          <div @click="toProducts(5)" class="cllapseItem">
            Optical Fiber Accessories
          </div>
          <div @click="toProducts(6)" class="cllapseItem">
            Optical Transmission
          </div>
          <div @click="toProducts(7)" class="cllapseItem">Server</div>
          <div @click="toProducts(8)" class="cllapseItem">Storage</div>
          <div @click="toProducts(9)" class="cllapseItem">Telecom Power</div>
        </el-collapse-item>
        <el-collapse-item title="About Us" name="2">
          <div class="cllapseItem" @click="toOverview">Company Overview</div>
          <div class="cllapseItem" @click="toCompanyNews">Company News</div>
          <div class="cllapseItem" @click="toAbout">Contact us</div>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>
  </el-container>
  <!-- </ScaleBox> -->
</template>

<script>
// import drawMixin from '@/utils/drawMixin.js'
// import ScaleBox from 'vue2-scale-box'
export default {
  // mixins: [drawMixin],
  // 初始值引起的问题,只需要在相应标签上加一个v-if不等于初始值就可以了
  data () {
    return {
      baseUrl: 'https://voystar.vpclub.cn/',
      show3: false,
      drawer: false,
      activeNames: [1, 2],
      solutionList: [
        {
          name: 'Solution One',
          img: require('@/assets/logo.png'),
          value: 1
        },
        {
          name: 'Solution Two',
          img: require('@/assets/logo.png'),
          value: 2
        },
        {
          name: 'Solution Three',
          img: require('@/assets/logo.png'),
          value: 3
        },
        {
          name: 'Solution Four',
          img: require('@/assets/logo.png'),
          value: 4
        }
      ],
      productsList: []
      // newList: []
    }
  },
  components: {
    // ScaleBox
  },
  created () {
    // this.productsList = JSON.parse(window.sessionStorage.getItem('homeData'))
    console.log('看看是什么', window.winHomeData)
    this.productsList = window.winHomeData
  },
  methods: {
    toHome () {
      this.drawer = false
      this.$router.push({
        path: '/'
      })
    },
    toSolutions (num) {
      this.$router.push({
        path: '/solutions',
        query: {
          num: num
        }
      })
    },
    toProducts (num) {
      this.drawer = false
      this.$router.push({
        path: '/products',
        query: {
          num: num
        }
      })
    },
    toRobotic (num) {
      if (num == 1) {
        this.$router.push({
          path: '/roboticDog'
        })
      } else {
        this.$router.push({
          path: '/unmannedAerialVehicle'
        })
      }
    },
    toCompanyNews () {
      this.drawer = false
      this.$router.push({
        path: '/companyNews'
      })
    },
    toOverview () {
      this.drawer = false
      this.$router.push({
        path: '/companyOverview'
      })
    },
    toAbout () {
      this.drawer = false
      this.$router.push({
        path: '/contractUs'
      })
    },
    wechatEnter () {
      this.$refs.wechat.style.display = 'block'
    },
    wechatLeave () {
      this.$refs.wechat.style.display = 'none'
    },
    wechatEnterCode () {
      this.$refs.wechatCode.style.display = 'block'
    },
    wechatLeaveCode () {
      this.$refs.wechatCode.style.display = 'none'
    },
    scaleChange (val) {
      console.log(val)
    }
  }
}
</script>
<style lang="less" scoped>
.layout {
  position: relative;
  .header {
    // padding: 0 350px;
    width: 100%;
    height: 100px !important;
    background-color: #1d2d49;
    color: #fff;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    .headermar {
      width: 1150px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .heaLeft {
        margin-right: 100px;
        .heaImg {
          width: 90px;
          height: 90px;
        }
        .hlTop {
          font-size: 24px;
          font-weight: 600;
          border-bottom: 5px solid #fff;
        }
        .hlbtm {
          font-size: 20px;
          font-weight: 600;
        }
      }
      .heaRight {
        display: flex;
        .rightBox {
          margin-right: 50px;
          color: #fff;
          cursor: pointer;

          /* 下拉按钮样式 */
          .dropbtn {
            font-size: 16px;
            cursor: pointer;
          }

          /* 容器 <div> - 需要定位下拉内容 */
          .dropdown {
            position: relative;
            display: inline-block;
          }

          /* 下拉内容 (默认隐藏) */
          .dropdown-content {
            display: none;
            position: absolute;
            background-color: #1d2d49;
            width: 200px;
            // min-width: 160px;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            p {
              color: #fff;
              border-bottom: 1px solid #9daaaa;
              margin: 0 15px;
              text-decoration: none;
              display: block;
              padding: 13px 0;
              font-size: 14px;
            }
            p:last-of-type {
              border-bottom: none;
            }
          }

          /* 在鼠标移上去后显示下拉菜单 */
          .dropdown:hover .dropdown-content {
            display: block;
          }
        }
      }
      .voyage {
        display: none;
      }
      .moreBox {
        display: none;
        .moreImg {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .main {
    padding: 0;
    // height: 800px;
    .mainInsid {
      background-color: #ebebeb;
      overflow: hidden;
    }

    .mainBox {
      width: 1150px;
      margin: 0 auto;
      .mainTop {
        background-color: #f2f2f2;
        // height: 300px;
        width: 100%;
        padding: 50px;
        // overflow: hidden;
        .mainItemTop {
          display: flex;
          justify-content: space-between;
          // margin: 20px 0;
          .mainTitle {
            font-size: 30px;
          }
          .more {
            font-size: 24px;
            font-weight: 700;
            cursor: pointer;
          }
        }
        .mainItemBtm {
          display: flex;
          justify-content: space-between;

          .mainItemCon {
            width: 230px;
            height: 230px;
            background-color: #fff;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            cursor: pointer;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            .mainItemImg {
              .mainImg {
                width: 100px;
                height: 100px;
              }
            }

            .mainText {
              font-size: 14px;
            }
          }
        }
      }
      .mainCenter {
        background-color: #ebebeb;
        // height: 300px;
        width: 100%;
        margin: 20px 0;
        // padding: 50px 350px;
        .mainItemTop {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          .mainTitle {
            font-size: 30px;
            color: #0057b8;
          }
          .more {
            font-size: 24px;
            font-weight: 700;
            cursor: pointer;
          }
        }
        .mainTitleSmall {
          display: none;
        }
        .mainCentItemBox {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          // margin-bottom: 50px;
          .mainItemBtm {
            display: flex;
            justify-content: space-between;
            .mainItemCon {
              width: 350px;
              height: 350px;
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              // border: 1px solid #797979;
              box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
              cursor: pointer;
              margin: 30px 0;
              h2 {
                // padding: 20px;
                font-size: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #d7d7d7;
              }
              .mainItemBox {
                // padding-top: 20px;
                text-align: left;
                // display: flex;

                .mainText {
                  // width: 300px;
                  // margin-top: 20px;
                }
                .mainItemImg {
                  text-align: center;
                  .mainImg {
                    width: 150px;
                    height: 150px;
                  }
                }
              }
            }
          }
        }
        .more {
          display: none;
        }
      }
    }
    .mainBoxTwo {
      width: 100%;
      background-color: #d7d7d7;
      .mainBtm {
        // background-color: ;
        // height: 300px;
        width: 1150px;
        margin: 0 auto;
        overflow: hidden;
        // padding: 50px 350px;
        .mainItemTop {
          text-align: center;
          margin: 50px 0;
          .mainTitle {
            font-size: 30px;
            color: #0057b8;
          }
        }
        .mainBtmBox {
          display: flex;
          align-content: center;
          justify-content: space-between;
          flex-wrap: wrap;
          .mainBtmBoxLeft,
          .mainBtmBoxRight {
            width: 420px;

            .itemLeftBox {
              width: 100%;
              height: 250px;
              background-color: #1d2d49;
              border-radius: 10px;
              padding: 20px 10px;
              display: flex;
              justify-content: space-between;
              margin-bottom: 40px;
              .itemLeft {
                width: 50px;
                height: 50px;
                background-color: #fff;
                border-radius: 50%;
                font-size: 20px;
                text-align: center;
                line-height: 50px;
              }
              .itemRight {
                flex: 1;
                color: #fff;
                padding: 10px 20px 0;
                word-wrap: break-word;
                word-break: break-all;
                // font-size: 16px;
                .itemRightTitle {
                  font-size: 20px;
                  margin-bottom: 20px;
                }
              }
            }
          }
          .mainBtmBoxCen {
            width: 300px;
            height: 300px;
            background-color: #1d2d49;
            border-radius: 50%;
            transform: translateY(40%);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .mainImg {
              width: 150px;
              height: 150px;
            }
            .mainbbcTop {
              color: #fff;
              // border-bottom: 2px solid #fff;
              font-size: 28px;
              font-weight: 600;
            }
            .mainbbcBtm {
              color: #fff;
              font-size: 22px;
            }
          }
        }
        .mainBtmBoxSmall {
          display: flex;
          align-content: center;
          justify-content: space-between;
          flex-wrap: wrap;
          .mainBtmBoxLeft {
            display: none;
            width: 420px;

            .itemLeftBox {
              width: 90%;
              height: 250px;
              background-color: #1d2d49;
              border-radius: 10px;
              padding: 20px 10px;
              display: flex;
              justify-content: space-between;
              margin: 0 auto 40px;

              .itemLeft {
                width: 50px;
                height: 50px;
                background-color: #fff;
                border-radius: 50%;
                font-size: 20px;
                text-align: center;
                line-height: 50px;
              }
              .itemRight {
                flex: 1;
                color: #fff;
                padding: 10px 20px 0;
                word-wrap: break-word;
                word-break: break-all;
                // font-size: 16px;
                .itemRightTitle {
                  font-size: 20px;
                  margin-bottom: 20px;
                }
              }
            }
          }
        }
      }
    }
  }

  .footer {
    height: 100px !important;
    background-color: #1d2d49;
    color: #d7d7ba;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // .aboutBox {
  //   // width: 100px;
  //   // height: 100px;
  //   position: fixed;
  //   right: 20px;
  //   bottom: 100px;
  //   .aboutCon {
  //     border: 1px solid #000;
  //     padding: 5px;
  //     border-radius: 10px;
  //     display: flex;
  //     flex-direction: column;
  //     align-content: center;
  //     flex-wrap: wrap;
  //     justify-content: space-between;
  //     margin-bottom: 20px;
  //     text-align: center;
  //     background-color: #fff;
  //     cursor: pointer;
  //     height: 70px;
  //     .aboutItem {
  //       .aboutImg {
  //         width: 30px;
  //         height: 30px;
  //       }
  //     }
  //     .aboutTxt {
  //       font-size: 16px;
  //     }
  //   }
  // }
  .aboutWechat {
    position: fixed;
    right: 20px;
    bottom: 300px;
    border: 1px solid #000;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    background-color: #fff;
    cursor: pointer;
    height: 70px;
    width: 120px;
    .aboutItem {
      .aboutImg {
        width: 30px;
        height: 30px;
      }
    }
    .aboutTxt {
      font-size: 16px;
    }
  }
  .aboutWhatsApp {
    position: fixed;
    right: 20px;
    bottom: 200px;
    border: 1px solid #000;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    background-color: #fff;
    cursor: pointer;
    height: 70px;
    width: 120px;
    .aboutItem {
      .aboutImg {
        width: 30px;
        height: 30px;
      }
    }
    .aboutTxt {
      font-size: 16px;
    }
  }
  .aboutPhone{
    position: fixed;
    right: 20px;
    bottom: 100px;
    border: 1px solid #000;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    background-color: #fff;
    cursor: pointer;
    height: 70px;
    .aboutItem {
      .aboutImg {
        width: 30px;
        height: 30px;
      }
    }
    .aboutTxt {
      font-size: 16px;
    }
  }

  .wechatBox {
    display: none;
    position: fixed;
    right: 120px;
    top: 615px;
    border: 1px solid #000;
    background-color: #fff;
    .wechatImg {
      width: 100px;
      height: 100px;
    }
  }
  .wechatBoxCode {
    display: none;
    position: fixed;
    right: 120px;
    top: 525px;
    border: 1px solid #000;
    background-color: #fff;
    .wechatImg {
      width: 100px;
      height: 100px;
    }
  }
  /deep/.el-collapse {
    margin-left: 10px;
  }
  /deep/.el-collapse-item__header {
    color: #000;
    font-weight: 700;
    font-size: 16px;
  }
  /deep/.el-collapse-item__content {
    font-size: 16px;
  }
  .collapseHome {
    border-bottom: 1px solid #ebeef5;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  .cllapseItem {
    line-height: 35px;
    cursor: pointer;
    padding-left: 10px;
  }
  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .main {
      .mainBox {
        // width: 800px;
        transition: width 0.5s ease-in-out;
      }
    }
  }
  //当屏幕宽度 最小为800px 最大为1300px时
  @media screen and (min-width: 800px) and (max-width: 1300px) {
    .header {
      .headermar {
        width: 100%;
        .heaLeft {
          .heaImg {
            width: 70px;
            height: 70px;
          }
        }
      }
    }
    .main {
      .mainBox {
        width: 750px;
        transition: width 0.5s ease-in-out;
      }
      .mainBoxTwo {
        .mainBtm {
          width: 100%;
          transition: width 0.5s ease-in-out;

          .mainBtmBox {
            display: none;
          }
          .mainBtmBoxSmall {
            display: flex;
            align-content: center;
            justify-content: center;
            flex-wrap: wrap;
            .mainBtmBoxLeft {
              display: block;
            }
          }
        }
      }
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .header {
      .headermar {
        width: 100%;
        transition: width 0.5s ease-in-out;
        justify-content: space-between;
        .heaLeft {
          margin-right: 0;
          .heaImg {
            width: 50px;
            height: 50px;
          }
        }
        .heaRight {
          display: none;
        }
        .voyage {
          display: block;
        }
        .moreBox {
          cursor: pointer;
          display: block;
        }
      }
    }

    .main {
      .mainBox {
        width: 100%;
        transition: width 0.5s ease-in-out;

        .mainCenter {
          .mainItemTop {
            display: none;
          }
          .mainTitleSmall {
            display: block;
            text-align: center;
          }
          .mainCentItemBox {
            justify-content: center;
            .mainItemBtm {
              width: 260px;
              .mainItemCon {
                width: 240px;
                height: 240px;
                // margin: 5px 0;
                h2 {
                  // padding: 20px;
                  font-size: 14px;
                  padding-bottom: 5px;
                  border-bottom: 1px solid #d7d7d7;
                }
                .mainItemBox {
                  // padding-top: 20px;
                  text-align: left;
                  // display: flex;
                  .mainText {
                    // width: 300px;
                    // margin-top: 20px;
                  }
                  .mainItemImg {
                    .mainImg {
                      width: 100px;
                      height: 100px;
                    }
                  }
                }
              }
            }
          }
          .more {
            display: block;
            text-align: center;
          }
        }
      }
      .mainBoxTwo {
        .mainBtm {
          width: 100%;
          transition: width 0.5s ease-in-out;
          .mainItemTop {
            .mainTitle {
              font-size: 24px;
            }
          }

          .mainBtmBox {
            display: none;
          }
          .mainBtmBoxSmall {
            display: flex;
            align-content: center;
            justify-content: center;
            flex-wrap: wrap;
            .mainBtmBoxLeft {
              display: block;
            }
          }
        }
      }
    }
    .footer {
      font-size: 14px;
    }
    .aboutBox {
      display: none;
    }
  }
}
</style>
